import { withChartLayout } from 'components/common';
import Allergies from 'components/features/chart/patient-data/Allergies';

const AllergiesPage = withChartLayout('Allergies')(Allergies);
export default AllergiesPage;
